<template>
  <div>
    <div class="card mb-25 border-0 rounded-0 mt-10">
      <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">

        <b-card-header>
          <div class="col-12 d-flex justify-content-between align-items-center ">
            <span class="fs-lg-19 fs-sm-10 fs-md-20"> 已分析比赛（{{ finishResultData.length }}）场 </span>
            <div class=" d-flex">
              <!-- Item View Radio Button Group  -->
              <b-form-radio-group v-model="itemView" class="ml-1 list item-view-radio-group" buttons size="sm"
                button-variant="outline-primary">
                <b-form-radio v-for="option in itemViewOptions" :key="option.value" :value="option.value">
                  <feather-icon :icon="option.icon" size="18" />
                </b-form-radio>
              </b-form-radio-group>
            </div>
          </div>
          <div class="col-12 text-center p-4 bg-primary text-light rounded mt-20" v-if="finishResultData.length == 0 && this.itemView == 'grid-view'">
            <feather-icon icon="UploadCloudIcon" size="40" class="blinking" />
            <div class="mb-3 mt-20">
              当前暂无已分析数据，正在云分析中<span class="blinking">...</span>
            </div>
          </div>
         
        </b-card-header>

        <div class="row mt-10 " v-if="this.itemView == 'grid-view'">
          <div class="col-lg-4 col-md-6 col-sm-12" v-for="item in finishResultData" :key="item.matchId" v-if="dataload">
            <MatchCard :matchData="item"></MatchCard>
          </div>
        </div>
        <div class="row mt-10" v-else>
          <div class="col-12">
            <MatchList :resultData="finishResultData" :matchStatus="'cp'" />
          </div>
        </div>


      </div>
    </div>

  </div>

</template>

<script>
import MatchList from '../components/MatchList.vue'
import MatchCard from '../components/MatchCardCp.vue'

import request from '@/utils/request.js';

import useAppConfig from '@core/app-config/useAppConfig'
import { computed } from '@vue/composition-api'



export default {
  components: {
    MatchList,
    MatchCard
  },
  data: function () {
    return {
      dataload:false,
      finishResultData: [],
      itemView: 'list-view',
      itemViewOptions: [
        { icon: 'GridIcon', value: 'grid-view' },
        { icon: 'ListIcon', value: 'list-view' },
      ],
    };
  },

  mounted() {
    this.getData();
  },


  methods: {

    async getData() {
      var post_url =
        'football//admin/william/interfaceAction!receiveAutoBetInfo.action?sjlx=ttyq' + '&cxlx=02';
    
      let opts = {
        type: 1, // 1为数据接口；2为静态资源请求  
        url: post_url,
        method: 'get'
      };

      if (!request.hadToken()) {
        return;
      }

      let res = await request.httpRequest(opts);
      const resList = res.data.listAutoBetInfo;
      this.finishResultData = resList;
      this.dataload  = true;
    },
  },
  setup() {
    const { skin } = useAppConfig()

    const isDark = computed(() => skin.value === 'dark')

    return { skin, isDark }
  },
}
</script>


<style lang="scss" scoped>
@import "~@core/scss/base/pages/app-ecommerce.scss";

[dir] .card-header {
  padding: 1rem 1.5rem;
}


/* 定义一个闪烁动画 */
@keyframes blink {

/* 从0%开始到100%，‌通过opacity属性在1（‌完全不透明）‌和0（‌完全透明）‌之间交替 */
0%,
100% {
  opacity: 1;
}

50% {
  opacity: 0;
}
}

/* 应用闪烁动画到一个类 */
.blinking {
/* 使用无限次重复闪烁动画 */
animation: blink 0.5s infinite;
}

.dark_bg {
background-color: #283046;
box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.24);
}
</style>


